import { gql } from "@apollo/client";

export const UPDATE_CLIENT_MUTATION = gql`
  mutation UpdateClient($clientData: ClientInput!, $id: Int!) {
    updateClient(clientData: $clientData, id: $id) {
      client {
        id
        name
        surname
      }
    }
  }
`;
